import { IAddress } from '@commenda/types';
import {
  CorporationHasDirectorAdditionalInformation,
  DirectorPersonalDetails,
} from '@commenda/types/src/random';
import { fetcher } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';

type DirectorFileToAdd = {
  fileName: string;
  fileUrl: string;
  documentType: LegacyDocumentType;
  serviceRequestTaskId?: number;
};

export type UpdateCorporationHasDirector = {
  corporationId: number;
  additionalDirectorInformation?: CorporationHasDirectorAdditionalInformation;
  filesToAdd?: DirectorFileToAdd[];
};

// TODO: This is not a full SDK, there are many properties on the API that aren't included here yet.
// Add more as required.
export type UpdateDirectorRequest = {
  corporationHasDirector?: UpdateCorporationHasDirector[];
  directorFirstName?: string;
  directorLastName?: string;
  operatingAddress?: IAddress;
  personalDetails?: DirectorPersonalDetails;
  dateOfBirth?: string;
  number?: string;
  email?: string;
  ssn?: string;
};

export async function updateDirector(
  directorId: number,
  director: UpdateDirectorRequest,
  token?: string
): Promise<Response> {
  const requestUrl = `director/${directorId}`;

  const res = await fetcher(requestUrl, {
    method: 'POST',
    body: director,
  });

  return res;
}
